import AuthModule from '@/users/store/auth-module'
import AccountModule from '@/users/store/account-module'

export default {
  AuthModule,
  AccountModule,
}
